import React, { useContext, useEffect, useMemo, useState } from 'react'
import Layout from '../Components/Layouts/Layout'
import AppraisalCustomerTable from '../Components/AppraisalResults/AppraisalCustomerTable'
import AppraisalFilterForm from '../Components/AppraisalResults/AppraisalFilterForm'
import { getImages } from '../Components/Const'
import { LeadsContext } from '../Components/Context/LeadsContext'
import ExportButton from '../Components/AppraisalResults/ExportButton'
import ModalLayoutNew from '../Components/Modals/ModalLayoutNew'
import AppraisalDetails from '../Components/Customers/AppraisalDetails'

const AppraisalResults = () => {
    const { getLeads, isInitialLoad, leadData, allLeads, leadsLoading } = useContext(LeadsContext);
    useEffect(() => {
        if (!isInitialLoad) {
            getLeads();
        }
    }, []);
    const [visibleData, setVisibleData] = useState([]);
    // console.log("visibleData", visibleData)
    const [appraisalModalOpen, setAppraisalModalOpen] = useState(false);
    const [appraisalData, setAppraisalData] = useState({});
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    // const [searchKeyword, setSearchKeyword] = useState("")
    const handleAppraisalDetails = (lead) => {
        setAppraisalData(lead);
        setAppraisalModalOpen(true)
        document.body.classList.add('overflow-body');
    }
    const handleAppraisalClose = () => {
        setAppraisalModalOpen(false);
        document.body.classList.remove('overflow-body');
    }
    const [filteredData, setFilteredData] = useState([]);
    console.log("filteredData", filteredData)
    const stableVisibleData = useMemo(() => visibleData, [visibleData]);
    useEffect(() => {
        if (!isFilterApplied) {
            setFilteredData(visibleData);
        }
    }, [visibleData]);
    const applyFilters = (data, filters) => {
        return data.filter(item => {
        const {
            make,
            model,
            year,
            status,
            location,
            vin,
            vehicle_status,
            vehicle_name,
            dateFrom,
            dateTo,
            phone
        } = filters;
        const itemYear = String(item.year);

        if (make !== "all" && item.make !== make) return false;
        if (model !== "all" && item.model !== model) return false;
        if (year !== "all" && itemYear !== String(year)) return false;
        if (status !== "all" && item.status !== status) return false;
        if (location !== "all" && item.location !== location) return false;
        if (vehicle_status !== "all" && item.vehicle_status !== vehicle_status) return false;

        if (vin && !item.vin?.toLowerCase().includes(vin.toLowerCase())) return false;
        if (vehicle_name && !item.vehicle_name?.toLowerCase().includes(vehicle_name.toLowerCase())) return false;


        if (dateFrom && new Date(item.date) < new Date(dateFrom)) return false;
        if (dateTo && new Date(item.date) > new Date(dateTo)) return false;

        if (phone && !item.phone?.includes(phone)) return false;

        return true;
        });
    };
    const handleFilterSubmit = (values) => {
        const isDefaultFilter =
            values.make === "all" &&
            values.model === "all" &&
            values.year === "all" &&
            values.status === "all" &&
            values.location === "all" &&
            values.vehicle_status === "all" && 
            !values.vin &&
            !values.keyword &&
            !values.phone &&
            !values.dateFrom &&
            !values.dateTo;

        if (isDefaultFilter) {
            setIsFilterApplied(false);
            setFilteredData(visibleData);
        } else {
            setIsFilterApplied(true);
            const results = applyFilters(visibleData, values);
            setFilteredData(results);
        }
    };
    const handleSearchChange = (value) => {
        // console.log("Keyword typed:", value);
        if (!value) {
            setFilteredData(visibleData);
            return;
        }

        const lowerValue = value.toLowerCase();

        const results = visibleData.filter(item =>
            item.vehicle_name?.toLowerCase().includes(lowerValue) ||
            item.phone?.toLowerCase().includes(lowerValue)
        );

        setFilteredData(results);
    };
    return (
        <>
            <Layout hideTopBar={true}>
                <section className='appraisal-result-wrap'>
                    <div className='container-fluid'>
                        <div className='ar-flex d-flex'>
                            <div className='ar-left'>
                                <AppraisalFilterForm
                                    visibleData={stableVisibleData}
                                    handleFilterSubmit={handleFilterSubmit}
                                    handleSearchChange={handleSearchChange}
                                />
                            </div>
                            <div className='ar-right'>
                                <div className='arr-heading-flex d-flex align-items-center justify-content-between'>
                                    <div className='md-title text-uppercase font-26'>SEARCH RESULTS</div>
                                    <div>
                                        <ExportButton visibleData={visibleData}/>
                                    </div>
                                </div>
                               <AppraisalCustomerTable
                                    leadAction={handleAppraisalDetails}
                                    leadData={leadData}
                                    allLeads={allLeads}
                                    leadsLoading={leadsLoading}
                                    visibleData={visibleData}
                                    setVisibleData={setVisibleData}
                                    filteredData={filteredData}
                               />
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
            {appraisalModalOpen &&
                <ModalLayoutNew open={appraisalModalOpen} close={handleAppraisalClose} darkThemeCls='true' modalWidth={1198}>
                    {<AppraisalDetails
                        close={handleAppraisalClose}
                        appraisalData={appraisalData}
                        // appraisalStage={appraisalStage}
                    />}
                </ModalLayoutNew>
            }
        </>
    )
}

export default AppraisalResults